import { AppBar, InputBase, Typography } from "@mui/material";
import { Search, StyledToolbar } from "../../styles/navbar";
import { Icons } from "../../styles/common";
import NavMenu from "./navMenu";
import { useState } from "react";
import SearchDialog from "../appDialog";



export default function NavBarDesktop({matches}){
    const [openSearch, setOpenSearch] = useState(false)
    const [chipTitle, setChipTitle] = useState(null)
    const [inputValue, setInputValue] = useState('');

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl)

    const handleKeyPress=(event)=>{
        if(event.key != "Enter") return
        if(inputValue.length == 0) return
        setChipTitle(inputValue)
        setOpenSearch(true)
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return(
        <AppBar position="sticky">
            <SearchDialog
                openSearch={openSearch} 
                setOpenSearch={setOpenSearch} 
                matches={matches}
                chipTitle={chipTitle}
            />
            <StyledToolbar>
                <Typography>52ywy.com</Typography>
                <Search>
                    <InputBase 
                        placeholder="搜索，输入博主名或是视频类型后按回车键..."
                        onKeyDown={handleKeyPress}
                        onChange={(e) => setInputValue(e.target.value)}
                        style={{
                            width:"100%"
                        }}
                    />
                </Search>
                <Icons>
                    
                </Icons>
            </StyledToolbar>
            <NavMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}></NavMenu>
        </AppBar>
    )
}